import styled from 'styled-components';

export const StyledCategoryMenu = styled.div`
  display: flex;
  position: absolute;
  top: ${(props) => props.theme.secondHeaderHeight};

  .wrapper-menu {
    display: flex;
    position: relative;
    z-index: 40;
  }

  .menu {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .product-count {
    font-size: 16px !important;
  }

  .category,
  .subcategory,
  .subsubcategory {
    &::-webkit-scrollbar {
      display: none;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      font-size: 16px;
      cursor: pointer;
      font-family: ${(props) => props.theme.fontText};
      position: relative;
      text-align: left;
      color: ${(props) => props.theme.colorText};
      padding: 12px 0 12px 7%;
      justify-content: space-between;

      &:after {
        content: '';
        display: block;
        width: 85%;
        height: 1px;
        background-color: ${(props) => props.theme.menuBorderBottom};
        position: absolute;
        bottom: 0;
        left: 7%;
      }

      .icon {
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 12px;
      }

      span:not(.icon) {
        font-family: ${(props) => props.theme.fontText};
        font-size: 12px;
        line-height: 22px;
        color: ${(props) => props.theme.productCount};
      }

      &.no-underline:after {
        width: 0;
      }
    }
  }

  .category {
    position: relative;
    width: 373px;
    overflow-y: auto;
    border-right: 1px solid ${(props) => props.theme.borderBottom};
    background-color: ${(props) => props.theme.white};
    scrollbar-width: thin;
  }

  .subcategory,
  .subsubcategory {
    position: absolute;
    top: 0;
    width: 373px;
    overflow-y: auto;
    background-color: ${(props) => props.theme.white};
    border-right: 1px solid ${(props) => props.theme.borderBottom};
    scrollbar-width: thin;
    height: 100%;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .subcategory {
    left: 373px;
  }

  .subsubcategory {
    left: 746px;
  }
`;
